import Search16 from '@carbon/icons-react/es/search/16';
import { InputProps } from 'antd/es/input';
import { FC, useState } from 'react';
import styled, { css } from 'styled-components';
import { IconShell } from '../icon-shell';
import { Input as StyledInput } from './input';

const SearchInput = styled(StyledInput)``;

const ExpandedInput = css`
  width: 100%;
  border: none;
`;

const InputGroup = css`
  margin: 0;
  width: 40px;
  outline: 2px solid;
  outline-color: currentcolor;
  outline-color: transparent;
  outline-offset: -2px;
  border: none;
  border-radius: 0;
  height: var(--input-height-default);
  background-color: var(--gray-10);
  display: flex;
  overflow: hidden;
  -webkit-transition: all 0.5s;
  -moz-transition: all 0.5s;
  transition: all 0.5s;
`;

const SearchWrapper = styled.div<{ hasContent?: boolean }>`
  ${InputGroup};

  &:hover {
    ${ExpandedInput};
  }

  ${({ hasContent }) => (hasContent ? ExpandedInput : '')}

  .ant-input-affix-wrapper {
    border: none;
    padding-left: 0px;
  }

  .ant-input {
    background: transparent;
  }

  .ant-input-affix-wrapper {
    box-shadow: none;
  }
`;

// DEAD CODE - To be removed

export const SearchBar: FC<InputProps> = (props): React.JSX.Element => {
  const [hasContent, setHasContent] = useState<boolean>(false);

  const handleOnInput = (
    e: React.ChangeEvent<HTMLInputElement> | undefined,
  ): void => {
    if (e != null) {
      setHasContent(!!e.target.value);

      // eslint-disable-next-line react/destructuring-assignment
      if (props.onChange) {
        // eslint-disable-next-line react/destructuring-assignment
        props.onChange(e);
      }
    }
  };

  return (
    <SearchWrapper hasContent={hasContent}>
      <IconShell icon={<Search16 />} />
      <SearchInput onChange={handleOnInput} allowClear {...props} />
    </SearchWrapper>
  );
};
